
import Vue from "vue";
import AppCreateUblArchiveModalWrapper from "./CreatePdfArchiveModalWrapper.vue";
import { BrowseState } from "@/utils/browse/browse-state";

export default Vue.extend({
	data(){
		return {
			beginDate: new Date(new Date().getFullYear(), 0, 1),
			endDate: new Date(new Date().getFullYear(), 11, 31),
			message: ""
		};
	},
	props: {
		browseState: {
			required: true,
			type: Object as () => BrowseState
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		create(){
			this.$emit("create", {beginDate: this.beginDate, endDate: this.endDate, message: this.message});
		}
	},
	components: {
		AppCreateUblArchiveModalWrapper,
	},
	i18nEx: {
		componentPrefix: "components.pdf-archive"
	}
});
